'use strict';

var StrategyReadonlyDirective = function StrategyReadonlyDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-readonly.html'),
    controller: 'StrategyReadonlyController',
    scope: {
      strategy: '=',
      closePanelHandler: '&',
      expandCollapseHandler: '&',
      showHideHandler: '&',
      showDragBar: '=',
      collapsed: '=',
      isHidden: '='
    }
  };
};
StrategyReadonlyDirective.$inject = [];
module.exports = StrategyReadonlyDirective;